import { RefreshCcw } from "lucide-react";
import React from "react";

import { IgButton, IgDialog, IgTypography } from "@intelligems/ig-theme";
import { Grid, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "@src/store";

import { getDialog, setDialog } from "../../store/slices/global";

export const UpdateDetectedDialog = () => {
  const dialog = useSelector(getDialog("updatedDetected"));
  const theme = useTheme();
  const shouldIgnore = useSelector(
    (state) => state.global.ignoreUpdateDetected
  );
  const dispatch = useDispatch();

  if (shouldIgnore) {
    return null;
  }

  return (
    <IgDialog
      handleClose={(event: any, reason: any) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          dispatch(setDialog({ dialog: "setDomain", open: false }));
        }
      }}
      rawContent={
        <Grid container item direction={"column"} rowSpacing={2}>
          <Grid item>
            <IgTypography>
              Updates have been made. Refresh <br /> the page to view the latest
              data.
            </IgTypography>
          </Grid>
          <Grid item>
            <IgButton
              startIcon={<RefreshCcw color={theme.igIconColors.dark} />}
              onClick={() => window.location.reload()}
              variant={"contained"}
            >
              Refresh Now
            </IgButton>
          </Grid>
        </Grid>
      }
      title={"Updates Detected"}
      showDialog={dialog.isOpen}
      hideActions={true}
      shouldNotClose={true}
      dialogHeight={null}
    />
  );
};
